import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

import { getPlatformStats } from "@/services/courseService";
import { ROUTE } from "@/route/app_routes.js";

const DISPLAY_NAME_OVERRIDES = {
  php: "PHP",
  css: "CSS",
  html: "HTML",
  mysql: "MySQL",
  nestjs: "NestJS",
  nodejs: "Node.js",
  nextjs: "Next.js",
  laravel: "Laravel",
  flutter: "Flutter",
  dart: "Dart",
  javascript: "JavaScript",
  "react native": "React Native",
  springboot: "Spring Boot",
};

const formatTech = (name) => DISPLAY_NAME_OVERRIDES[name.toLowerCase()] || name;

// Rotates the chip's letter-avatar through the brand accent palette -- gives each chip a
// distinct identity without needing a real per-technology brand logo at runtime.
const AVATAR_ACCENTS = ["var(--color-primary)", "var(--color-secondary)", "var(--color-coral)", "var(--color-info)", "var(--color-success)", "var(--color-violet)"];

const TechMarquee = () => {
  const { t } = useTranslation("home");
  const router = useRouter();
  const [technologies, setTechnologies] = useState([]);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    getPlatformStats()
      .then((res) => setTechnologies(res.data?.technologies || []))
      .catch(() => {});
  }, []);

  // Duplicated once so the CSS-only marquee can loop seamlessly at -50% translateX.
  const marqueeItems = technologies.length ? [...technologies, ...technologies] : [];

  const handleTechClick = (tech) => {
    router.push(`${ROUTE.course}?search=${encodeURIComponent(formatTech(tech))}`);
  };

  if (marqueeItems.length === 0) return null;

  return (
    <div className="rbt-marquee2">
      <div className="container">
        <span className="rbt-marquee2__eyebrow">{t("techMarquee.eyebrow", "Real skills you'll actually build")}</span>
      </div>

      <div className="rbt-marquee2__track-wrap">
        <div className={`rbt-marquee2__track ${paused ? "is-paused" : ""}`}>
          {marqueeItems.map((tech, i) => (
            <button
              type="button"
              className="rbt-marquee2__chip"
              key={`${tech}-${i}`}
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
              onClick={() => handleTechClick(tech)}
            >
              <span
                className="rbt-marquee2__avatar"
                style={{ background: AVATAR_ACCENTS[i % AVATAR_ACCENTS.length] }}
                aria-hidden="true"
              >
                {formatTech(tech).charAt(0).toUpperCase()}
              </span>
              {formatTech(tech)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechMarquee;
